import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorSC } from './error.styled';

type TProps = {
  message?: string | boolean;
  translate?: boolean;
  className?: string;
};
const Error: React.FC<TProps> = ({ message, translate, className }) => {
  if (typeof message === 'string' && message) {
    return (
      <ErrorSC className={className}>
        {translate ? <FormattedMessage id={message} /> : message}
      </ErrorSC>
    );
  }
  return null;
};

Error.defaultProps = {
  translate: true,
};

export default Error;
